import { ResourceProps } from 'react-admin';
import { Subscriptions } from '@mui/icons-material';

const Index: ResourceProps = {
  icon: Subscriptions,
  name: 'subscriptions',
};

export default Index;
